/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Table,
  Row,
  Col,
  message,
  Input,
  DatePicker,
  Button,
  Popconfirm,
  Select,
  Tooltip,
} from "antd";
import {
  camelCase,
  serialNum,
  getStartAndEndDate,
  capitaliseWithHyphen,
  normalizeString,
  toCapitalizedFormat,
  formatDateTime,
  routeListCapitalizedFormat,
  checkNumbervalue,
  checkSpace,
  checkSpecialCharacter,
} from "../../../../utils";
import urls from "../../../../api/urls";
import API from "../../../../api";
import search_icon from "../../../../assests/images/search-icon.svg";

import Smcs_Loader from "../../../../assests/images/loader-new.gif";

import moment from "moment";
import TotalCount from "../countCompo";
import ExpectionModal from "../ExceptionModal";
import axios from "axios";
import nodeURLs from "../../../../api/nodeUrls";
import { render } from "@testing-library/react";
import ExpectionSearchAndDateFilter from "../ExpectionSearchAndDateFilter";

const { GET_EXCEPTION_ACTIONS, UPDATE_EXCEPTION_REPORT, GET_EXCEPTION_REPORT } =
  nodeURLs;

const { RangePicker } = DatePicker;
const { Option } = Select;

const ShipmentReport = ({ activeKey }) => {
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState();
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [startAndEndDate, setStartAndEndDate] = useState({});
  const [serachValue, setSerachValue] = useState(null);
  const userId = JSON.parse(localStorage.getItem("userId"));

  ////////////////////////////////////
  const [selectedActions, setSelectedActions] = useState({});
  const [actionData, setActionsData] = useState([]);
  const [filterType, setFilterType] = useState("ALL");

  const [visible, setVisible] = useState(false);
  const [dateRangeStatus, setDateRangeStatus] = useState(false);
  const [editAwbData, setEditAwbData] = useState(null);
  const [filterOptions, setFilterOptions] = useState({});

  /////////////////////////////////

  useEffect(() => {
    if (activeKey == "2") {
      let todaysDate = moment(new Date(), "ddd MMM DD YYYY HH:mm:ss").format(
        "DD-MM-YYYY"
      );
      let twoDaysBack = moment().subtract(1, "days").format("DD-MM-YYYY");
      if (startAndEndDate?.start) {
        getManifest(
          pageNum,
          pageSize,
          startAndEndDate.start,
          startAndEndDate.end,
          null,
          filterType
        );
      } else {
        setStartAndEndDate({ start: twoDaysBack, end: todaysDate });
        getManifest(
          pageNum,
          pageSize,
          twoDaysBack,
          todaysDate,
          null,
          filterType
        );
      }
      if (actionData?.length == 0) {
        getActions();
      }
    }
  }, [activeKey]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (serachValue?.length > 0) {
        getManifest(
          0,
          pageSize,
          startAndEndDate?.start,
          startAndEndDate?.end,
          serachValue
        ); //search api call
      } else if (serachValue === "") {
        getManifest(
          pageNum,
          pageSize,
          startAndEndDate?.start,
          startAndEndDate?.end
        );
      }
    }, 900);
    return () => clearTimeout(delayDebounceFn);
  }, [serachValue]);

  const onShowSizeChange = (current, pageSize) => {
    getManifest(
      current,
      pageSize,
      startAndEndDate.start,
      startAndEndDate.end,
      null,
      filterType
    );
  };

  function handlefilterChange(params) {
    setFilterType(params.toUpperCase());
    setSerachValue(null);
    getManifest(
      pageNum,
      pageSize,
      startAndEndDate.start,
      startAndEndDate.end,
      null,
      params.toUpperCase()
    );
  }

  const confirmAction = (record) => {
    message.success(`${record?.awb_number} has been updated`);
    setSelectedActions((prevActions) => ({
      ...prevActions,
      [record.exception_id]: null,
    }));
    updateExceptions(record, selectedActions[record.exception_id]);
  };

  const handleActionSelect = (value, record, obj) => {
    setSelectedActions((prevActions) => ({
      ...prevActions,
      [record.exception_id]: obj?.key,
      [record.value]: obj.value,
    }));
  };

  function handleEditModal(params) {
    setVisible(true);
    setEditAwbData(params);
  }

  // function toCapitalizedFormat(str) {
  //   return str
  //     .toLowerCase()
  //     .replace(/\b\w/g, (chr) => chr.toUpperCase())
  //     .replace(/>\s*\w/g, (chr) => chr.toUpperCase());
  // }

  const getColumnSearchProps = (dataIndex, filterList) => ({
    filters: filterList?.map((value) => ({
      text: capitaliseWithHyphen(value),
      value,
    })),
    onFilter: (value, record) => record[dataIndex]?.includes(value),
  });

  const columns = [
    {
      title: "Sl No",
      align: "center",
      width: 10,
      render: (a, b, idx) => serialNum(pageSize, pageNum, idx),
    },
    {
      title: "AWB Number",
      dataIndex: "awb_number",
      width: 15,
      key: "awb_number",
      render: (text) => text,
    },

    {
      title: "Route",
      dataIndex: "route",
      key: "route",
      width: 20,
      render: (text, record) => {
        return text ? (
          <div>
            <Tooltip
              placement="rightTop"
              title={
                record?.route_list &&
                routeListCapitalizedFormat(record?.route_list)
              }
            >
              {toCapitalizedFormat(text)}
              {/* {record?.route} */}
            </Tooltip>
          </div>
        ) : (
          "--"
        );
      },
    },
    {
      title: "Overage Hub",
      dataIndex: "overage_premise",
      key: "overage_premise",
      sorter: (a, b) => {
        const nameA = a.overage_premise || "";
        const nameB = b.overage_premise || "";

        if (!a.overage_premise && b.overage_premise) return 1;
        if (a.overage_premise && !b.overage_premise) return -1;
        return nameA.localeCompare(nameB);
      },
      ...getColumnSearchProps(
        "overage_premise",
        filterOptions?.overage_premise
      ),
      width: 20,

      render: (text) => <div> {capitaliseWithHyphen(text) || "--"}</div>,
    },

    {
      title: "Shortage Hub",
      dataIndex: "shortage_premise",
      key: "shortage_premise",
      sorter: (a, b) => {
        const nameA = a.shortage_premise || "";
        const nameB = b.shortage_premise || "";

        if (!a.shortage_premise && b.shortage_premise) return 1;
        if (a.shortage_premise && !b.shortage_premise) return -1;
        return nameA.localeCompare(nameB);
      },
      width: 20,
      ...getColumnSearchProps(
        "shortage_premise",
        filterOptions?.shortage_premise
      ),

      render: (text) => <div>{camelCase(text) || "--"}</div>,
    },
    {
      title: "Misroute",
      dataIndex: "exception_type",
      key: "exception_type",
      width: 10,
      render: (text) => <div>{text === "MISSROUTE" ? "Yes" : "No"}</div>,
    },
    {
      title: "Booking",
      dataIndex: "is_booking",
      key: "is_booking",
      width: 10,
      render: (text) => <div>{text == true ? "Yes" : "No"}</div>,
    },
    {
      title: "Operation",
      dataIndex: "currentstatus",
      width: 15,
      key: "awb_number",
      render: (text, record) => (
        <div>{normalizeString(record?.currentstatus?.operation) || "--"}</div>
      ),
    },
    {
      title: "Reason",
      dataIndex: "exception_type",
      key: "exception_type",
      width: 20,
      render: (text, record) => {
        if (typeof record?.actions == "string") {
          return <div>{camelCase(text)}</div>;
        } else {
          return <div>{camelCase(record?.actions[0]?.reason) || "--"}</div>;
        }
      },
    },

    {
      title: "Last Status",
      dataIndex: "lastStatus",
      key: "lastStatus",
      width: 10,
      render: (text, record) => (
        <div>
          {normalizeString(record?.actions[0]?.action) ||
            camelCase(record?.current?.status) ||
            "--"}
        </div>
      ),
    },
    {
      title: "Type",
      dataIndex: "exception_type",
      key: "exception_type",
      width: 10,
      render: (text) => <div>{camelCase(text) || "--"}</div>,
    },

    {
      title: "Last Updated(Date and time)",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 20,
      render: (text, rec) => <div>{formatDateTime(rec) || "--"}</div>,
    },
    {
      title: "Last Updated by",
      dataIndex: "lastUpdatedBy",
      key: "lastUpdatedBy",
      width: 20,
      render: (text, rec) => <div>{camelCase(rec?.premise_name) || "--"}</div>,
    },

    // {
    //   title: "Reason",
    //   dataIndex: "exception_type",
    //   key: "exception_type",
    //   width: 20,
    //   render: (text, record) => {
    //     if (typeof record?.actions == "string") {
    //       return <div>{camelCase(text)}</div>;
    //     } else {
    //       return <div>{camelCase(record?.actions[0]?.reason) || "--"}</div>;
    //     }
    //   },
    // },
    // {
    //   title: "Action",
    //   dataIndex: "",
    //   width: 20,
    //   fixed: "right",
    //   key: "",
    //   // render: (text, record) => (
    //   //   <div>
    //   //     <Popconfirm
    //   //       title={`Do you want to ${selectedActions[
    //   //         record?.value
    //   //       ]?.toLowerCase()}?`}
    //   //       visible={!!selectedActions[record.exception_id]}
    //   //       onConfirm={() => confirmAction(record)}
    //   //       onCancel={() =>
    //   //         setSelectedActions((prevActions) => ({
    //   //           ...prevActions,
    //   //           [record.exception_id]: null,
    //   //         }))
    //   //       }
    //   //     >
    //   //       <Select
    //   //         className={
    //   //           record?.lastStatus?.toLowerCase() == "damaged"
    //   //             ? "exception-report-action-btn"
    //   //             : "exception-report-action-dis-btn"
    //   //         }
    //   //         // defaultValue="Take action"
    //   //         value={
    //   //           // selectedActions[record._id] ||
    //   //           // record?.action?.name ||
    //   //           "TAKE ACTION"
    //   //         }
    //   //         disabled={record?.lastStatus?.toLowerCase() == "damaged"}
    //   //         // style={{ width: 120 }}
    //   //         onSelect={(value, obj) => handleActionSelect(value, record, obj)}
    //   //         // options={actionData}
    //   //       >
    //   //         {actionData?.map((item) => (
    //   //           <Option key={item?.id} value={item?.name}>
    //   //             {item?.name}
    //   //           </Option>
    //   //         ))}
    //   //       </Select>
    //   //     </Popconfirm>
    //   //   </div>
    //   // ),
    //   render: (text, record) => {
    //     return (
    //       <Button
    //         className="save-btn"
    //         onClick={() => handleEditModal(record)}
    //         disabled={record?.lastStatus?.toUpperCase() == "DAMAGED"}
    //       >
    //         TAKE ACTION
    //       </Button>
    //     );
    //   },
    // },
  ];

  const getManifest = async (
    pageNum = null,
    pageSize = null,
    start = null,
    end = null,
    search = null,
    exceptionType = null
  ) => {
    setLoading(true);

    let params;
    if (search) {
      params = {
        page: pageNum,
        limit: pageSize,
        type: "Shipment",
        exceptionType:
          exceptionType == "ALL"
            ? "MISSROUTE,DAMAGE,DISCARDED,MISSING_OPERATION"
            : exceptionType, // OVERAGE
        startDate: start || null,
        endDate: end || null,
        search,
      };
    } else {
      setSerachValue(null);
      params = {
        page: pageNum,
        limit: pageSize,
        type: "Shipment",
        exceptionType:
          exceptionType == "ALL"
            ? "MISSROUTE,DAMAGE,DISCARDED,MISSING_OPERATION"
            : exceptionType, // OVERAGE
        startDate: start,
        endDate: end,
        // search,
      };
    }

    const response = await API.Api(GET_EXCEPTION_REPORT).NodeGetWithPremise(
      params
    );

    if (response?.status) {
      setLoading(false);
      let temp = [];
      let data = response?.response?.data?.exceptions;

      data?.forEach((e, index) => {
        temp.push({ ...e, slno: index + 1 });
      });
      setDataSource(temp);
      const uniqueOveragePremise = [
        ...new Set(temp?.map((item) => item?.overage_premise)),
      ];
      const uniqueShortagePremise = [
        ...new Set(temp?.map((item) => item?.shortage_premise)),
      ];

      setFilterOptions({
        overage_premise: uniqueOveragePremise.filter(Boolean),
        shortage_premise: uniqueShortagePremise.filter(Boolean),
      });

      setTotal(response?.response?.data?.pagination?.totalFields);
      return temp;
    } else {
      setLoading(false);
      message.error(response?.response?.statusText || "Internal server error");
    }
  };

  const updateExceptions = async (data, id) => {
    setLoading(true);

    let payload = {
      hubId: userId?.userInfo?.premiseId,
      actionId: +id,
      awbNumber: data?.awb_number,
    };
    const response = await API.Api(
      UPDATE_EXCEPTION_REPORT + `${data?.exception_id}`
    ).NodePutPremiseIdHeader(payload);

    if (response?.status) {
      setLoading(false);
      getManifest(
        pageNum,
        pageSize,
        startAndEndDate?.start,
        startAndEndDate?.end
      );
    } else {
      setLoading(false);
      message.error(response?.statusText || "Internal server error");
    }
  };

  const getActions = async () => {
    setLoading(true);

    const response = await API.Api(GET_EXCEPTION_ACTIONS).NodeGetWithPremise();

    if (response?.status) {
      setLoading(false);
      setActionsData(response?.response?.data?.actions);
    } else {
      setLoading(false);
      message.error(response?.statusText || "Internal server error");
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const handleOnclick = () => {
    getManifest(
      pageNum,
      pageSize,
      startAndEndDate?.start,
      startAndEndDate?.end,
      null,
      filterType
    );
  };

  function handlePageChange(pagination) {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);

    getManifest(
      pageNum,
      pageSize,
      startAndEndDate?.start,
      startAndEndDate?.end,
      null,
      filterType
    );
  }

  const disabledDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handleDateChange = (prarms, p2) => {
    const StartDate = moment(p2[0], "DD/MM/YYYY").format("DD-MM-YYYY");
    const endDate = moment(p2[1], "DD/MM/YYYY").format("DD-MM-YYYY");
    setStartAndEndDate({ start: StartDate, end: endDate });
    if (p2[0]?.length === 0) {
      // getTableData();
      setDateRangeStatus(false);
    } else {
      setDateRangeStatus(true);
    }

    // getManifest(pageNum, pageSize, StartDate, endDate);
  };

  const handleInputChange = (e) => {
    setSerachValue(e.target.value);
  };

  const handleCallBack = (e) => {
    getManifest(
      pageNum,
      pageSize,
      startAndEndDate?.start,
      startAndEndDate?.end,
      null,
      filterType
    );
  };

  return (
    <>
      <div className="consolidated-manifest-cntr m-1">
        <ExpectionModal
          visible={visible}
          setVisible={setVisible}
          type="shipment"
          handleCallBack={handleCallBack}
          editAwbData={editAwbData}
        />

        <div className="new-header ml-1">
          {/* <Row gutter={12} justify={"space-between"}>
            <Col className="center" span={6}>
              <Input
                placeholder="Search by shipment AWB number"
                bordered
                style={{
                  borderRadius: "5px",
                  height: "40px",
                  width: "100%",
                }}
                onKeyPress={(event) => {
                  if (
                    checkNumbervalue(event) ||
                    checkSpace(event) ||
                    checkSpecialCharacter(event)
                  ) {
                    event.preventDefault();
                  }
                }}
                maxLength={14}
                value={serachValue}
                suffix={<img src={search_icon} />}
                onChange={handleInputChange}
              />
            </Col>
            <div className="center">
              <div className="center">
                <div className="flex-end">
                  <RangePicker
                    onChange={handleDateChange}
                    format={"DD/MM/YYYY"}
                    disabledDate={(current) => disabledDate(current)}
                    defaultValue={[moment().subtract(1, "days"), moment()]}
                    style={{
                      borderRadius: "5px 0 0 5px",
                      height: "40px",
                      width: "230px",
                    }}
                  />
                  <Button
                    className="center mr-1"
                    disabled={!dateRangeStatus}
                    style={{
                      width: "40px",
                      height: "40px",
                      border: "1px solid #d9d9d9",
                      borderRadius: "0 5px 5px 0",
                    }}
                    onClick={handleOnclick}
                  >
                    <img src={search_icon} />
                  </Button>
                </div>
              </div>

              <div className="center">
                <Select
                  className="filter-select mr-1"
                  style={{
                    width: 140,
                  }}
                  value={filterType}
                  onChange={handlefilterChange}
                  options={[
                    {
                      value: "DAMAGE",
                      label: "Damage",
                    },
                    {
                      value: "DISCARDED",
                      label: "Discarded",
                    },
                    {
                      value: "MISSROUTE",
                      label: "Miss Route",
                    },
                    {
                      value: "MISSING_OPERATION",
                      label: "Missing Operation",
                    },
                    {
                      value: "ALL",
                      label: "All",
                    },
                  ]}
                />
              </div>
              <div className="center">
                <TotalCount count={total} />
              </div>
              <div className="center">
                <Button
                  className="save-btn"
                  onClick={() => (setVisible(true), setEditAwbData(null))}
                >
                  ADD NEW EXCEPTIONS
                </Button>
              </div>
            </div>
          </Row> */}
          <ExpectionSearchAndDateFilter
            serachValue={serachValue}
            handleInputChange={handleInputChange}
            handleDateChange={handleDateChange}
            dateRangeStatus={dateRangeStatus}
            handleOnclick={handleOnclick}
            filterType={filterType}
            handlefilterChange={handlefilterChange}
            total={total}
            onClicked={() => (setVisible(true), setEditAwbData(null))}
            bag={false}
            options={[
              {
                value: "DAMAGE",
                label: "Damage",
              },
              {
                value: "DISCARDED",
                label: "Discarded",
              },
              {
                value: "MISSROUTE",
                label: "Miss Route",
              },
              {
                value: "MISSING_OPERATION",
                label: "Missing Operation",
              },
              {
                value: "ALL",
                label: "All",
              },
            ]}
          />
        </div>

        <Table
          columns={columns}
          dataSource={dataSource}
          // dataSource={dataSource2}
          scroll={{
            x: 2000,
            y: 500,
          }}
          onChange={handlePageChange}
          pagination={{
            showSizeChanger: true,
            onShowSizeChange: onShowSizeChange,
            pageSizeOptions: [50, 100, 150, 200, 500],
            pageSize: pageSize,
            total: total,
            itemRender: itemRender,
            current: pageNum,
          }}
          // rowClassName={(record) => !record?.lost?.length && "disabled-row"}
          loading={{
            indicator: (
              <img
                src={Smcs_Loader}
                style={{ height: "100px", width: "100px" }}
              />
            ),

            spinning: loading,
          }}
        />
      </div>
    </>
  );
};

// export default BagShortageActionReport;

export default ShipmentReport;
